var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        "custom-class": "yxtbiz_gwnl_custom_drawer",
        "destroy-on-close": true,
        size: "1060px",
        visible: _vm.dialogVisible,
        "before-close": _vm.beforeDrawClose,
        title: _vm.$t("pc_biz_select_training_label"),
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-select-training-projects" }, [
        _c("div", { staticClass: "yxtbiz-select-training-projects-wrap" }, [
          _c(
            "div",
            [
              _c(
                "yxt-popover",
                {
                  attrs: {
                    "append-to-body": false,
                    "popper-class": "yxtbiz-exam-arrange-selector__popover",
                    placement: "bottom-start",
                    "visible-arrow": false,
                  },
                  model: {
                    value: _vm.showMoreFilter,
                    callback: function ($$v) {
                      _vm.showMoreFilter = $$v
                    },
                    expression: "showMoreFilter",
                  },
                },
                [
                  _c(
                    "yxt-button",
                    {
                      staticClass: "yxtbiz-filter-btn mr12",
                      attrs: { slot: "reference", plain: "" },
                      slot: "reference",
                    },
                    [
                      _c("yxt-svg", {
                        staticClass: "v-top",
                        attrs: {
                          width: "20px",
                          height: "20px",
                          "icon-class": "filter",
                        },
                      }),
                      _c("span", { staticClass: "ml8 v-top" }, [
                        _vm._v(_vm._s(_vm.$t("pc_biz_common_lbl_moreFilter"))),
                      ]),
                      _c("i", {
                        staticClass: "ml8",
                        class: _vm.showMoreFilter
                          ? "yxt-icon-arrow-up"
                          : "yxt-icon-arrow-down",
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form",
                    { attrs: { inline: true } },
                    [
                      _c(
                        "yxt-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "yxt-col",
                            { staticClass: "mb12", attrs: { span: 12 } },
                            [
                              _c(
                                "yxt-form-item",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    label: _vm.$t(
                                      "pc_biz_training_lbl_publishdate"
                                    ) /* 测训项目发布时间 */,
                                  },
                                },
                                [
                                  _c("yxt-date-picker", {
                                    attrs: {
                                      format: "yyyy-MM-dd",
                                      type: "daterange",
                                      "range-separator":
                                        _vm.$t("pc_biz_ote_lbl_to"),
                                      "start-placeholder": _vm.$t(
                                        "pc_biz_ote_lbl_starttime"
                                      ),
                                      "end-placeholder": _vm.$t(
                                        "pc_biz_ote_lbl_endtime"
                                      ),
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.search(1)
                                      },
                                    },
                                    model: {
                                      value: _vm.publishDate,
                                      callback: function ($$v) {
                                        _vm.publishDate = $$v
                                      },
                                      expression: "publishDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "yxt-col",
                            { staticClass: "mb12", attrs: { span: 12 } },
                            [
                              _c(
                                "yxt-form-item",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    label: _vm.$t(
                                      "pc_biz_training_status"
                                    ) /* 测训项目状态 */,
                                  },
                                },
                                [
                                  _c(
                                    "yxt-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        size: "large",
                                        placeholder: _vm.$t(
                                          "pc_biz_ote_lbl_pleaseselect"
                                        ),
                                        multiple: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.search(1)
                                        },
                                      },
                                      model: {
                                        value: _vm.statusArray,
                                        callback: function ($$v) {
                                          _vm.statusArray = $$v
                                        },
                                        expression: "statusArray",
                                      },
                                    },
                                    _vm._l(
                                      _vm.statusFilterOptions,
                                      function (item) {
                                        return _c("yxt-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "yxt-col",
                            { staticClass: "mb12", attrs: { span: 12 } },
                            [
                              _c(
                                "yxt-form-item",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    label: _vm.$t(
                                      "pc_biz_training_starttime"
                                    ) /* 测训项目开始时间 */,
                                  },
                                },
                                [
                                  _c("yxt-date-picker", {
                                    attrs: {
                                      format: "yyyy-MM-dd",
                                      type: "daterange",
                                      "value-format": "yyyy-MM-dd",
                                      "range-separator":
                                        _vm.$t("pc_biz_ote_lbl_to"),
                                      "start-placeholder": _vm.$t(
                                        "pc_biz_ote_lbl_starttime"
                                      ),
                                      "end-placeholder": _vm.$t(
                                        "pc_biz_ote_lbl_endtime"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.search(1)
                                      },
                                    },
                                    model: {
                                      value: _vm.startDate,
                                      callback: function ($$v) {
                                        _vm.startDate = $$v
                                      },
                                      expression: "startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "yxt-col",
                            { staticClass: "mb12", attrs: { span: 12 } },
                            [
                              _c(
                                "yxt-form-item",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    label: _vm.$t(
                                      "pc_biz_training_source"
                                    ) /* 测训项目来源 */,
                                  },
                                },
                                [
                                  _c(
                                    "yxt-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        size: "large",
                                        placeholder: _vm.$t(
                                          "pc_biz_ote_lbl_pleaseselect"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.search(1)
                                        },
                                      },
                                      model: {
                                        value: _vm.params.source,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.params, "source", $$v)
                                        },
                                        expression: "params.source",
                                      },
                                    },
                                    _vm._l(_vm.sourceOptions, function (item) {
                                      return _c("yxt-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "yxt-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "yxt-form-item",
                                {
                                  attrs: {
                                    "label-width": "100px",
                                    label: _vm.$t(
                                      "pc_biz_training_category"
                                    ) /* 测训项目分类 */,
                                  },
                                },
                                [
                                  _c(
                                    "yxt-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        size: "large",
                                        placeholder: _vm.$t(
                                          "pc_biz_ote_lbl_pleaseselect"
                                        ),
                                        multiple: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.search(1)
                                        },
                                      },
                                      model: {
                                        value: _vm.params.categoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.params,
                                            "categoryIds",
                                            $$v
                                          )
                                        },
                                        expression: "params.categoryIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryOptions,
                                      function (item) {
                                        return _c("yxt-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.categoryName,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("yxt-input", {
                staticClass: "mb16",
                staticStyle: { width: "240px" },
                attrs: {
                  placeholder: _vm.$t(
                    "pc_biz_gwnl_training_placeholder_inputName"
                  ),
                  searchable: "",
                },
                on: {
                  search: function ($event) {
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.params.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "keyword", $$v)
                  },
                  expression: "params.keyword",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-select-training-projects-table" },
            [
              _c(
                "yxt-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "table",
                  attrs: {
                    data: _vm.list,
                    "row-key": _vm.getRowKey,
                    height: "100%",
                    "default-sort": {
                      prop: _vm.params.orderby,
                      order: _vm.params.direction,
                    },
                  },
                  on: {
                    "sort-change": _vm.handleSortChange,
                    "select-all": _vm.selectAll,
                    select: _vm.select,
                  },
                },
                [
                  _c("yxt-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55",
                    },
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      prop: "trainingName",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("pc_biz_gwnl_training_lbl_title"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.trainingName || "--") +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      label: _vm.$t("pc_biz_training_lbl_classification"),
                      prop: "categoryName",
                      "show-overflow-tooltip": "",
                      width: "120",
                    },
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "120px",
                      prop: "status",
                      label: _vm.$t("pc_biz_gwnl_eval_lbl_status"),
                      "hide-column": "disable",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "yxt-tag",
                              {
                                staticStyle: { padding: "0" },
                                attrs: {
                                  "is-status-tag": "",
                                  type: _vm.statusOptions[row.publishStatus]
                                    .type,
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.statusOptions[row.publishStatus].label
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      prop: "publishUser",
                      label: _vm.$t("pc_biz_gwnl_lbl_publishperson"),
                      "show-overflow-tooltip": "",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("yxtbiz-user-name", {
                              attrs: { name: scope.row.publishUser || "--" },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      sortable: "custom",
                      prop: "updateTime",
                      label: _vm.$t("pc_biz_gwnl_task_publish_time"),
                      "show-overflow-tooltip": "",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "nowrap" }, [
                              _vm._v(_vm._s(scope.row.updateTime)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "clearfix mt16 flex" },
            [
              _c(
                "yxt-button",
                {
                  attrs: {
                    type: "text",
                    loading: _vm.isSearchingAll,
                    disabled: !_vm.list.length,
                  },
                  on: { click: _vm.searchAll },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "pc_biz_shoptour_all_filter_results" /*全选筛选结果*/
                        )
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "col-flex-1" },
                [
                  _c("yxt-pagination", {
                    staticClass: "pull-right",
                    attrs: {
                      "current-page": _vm.pager.currentPage,
                      "page-size": _vm.pager.pageSize,
                      layout: "total, prev, pager, next",
                      total: _vm.pager.total,
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.pager, "currentPage", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.pager, "currentPage", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "select-training__result" }, [
          _c("div", { staticClass: "result-list" }, [
            _c(
              "div",
              { staticClass: "result-list__content" },
              [
                !_vm.selectedList.length
                  ? _c(
                      "yxt-button",
                      {
                        staticClass: "result-list__select-tip",
                        attrs: { type: "text", disabled: "" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("pc_comp_select_placeholder")) +
                            "...\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "result-list__select-count" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_selected")) +
                      " " +
                      _vm._s(_vm.selectedList.length) +
                      " / " +
                      _vm._s(_vm.limit)
                  ),
                ]),
                _c(
                  "div",
                  { staticStyle: { height: "100%", overflow: "hidden" } },
                  [
                    _c(
                      "yxt-scrollbar",
                      { attrs: { "fit-height": true } },
                      _vm._l(_vm.selectedList, function (item) {
                        return _c(
                          "div",
                          { key: item.id },
                          [
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: item.trainingName,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { display: "inline-block" } },
                                  [
                                    _c(
                                      "yxt-tag",
                                      {
                                        staticClass:
                                          "select-training__tag mb5 mr5 ellipsis",
                                        staticStyle: { "max-width": "160px" },
                                        attrs: {
                                          type: "info",
                                          size: "mini",
                                          closable: "",
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.handleSelectionClose(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "select-training__taglabel",
                                          },
                                          [_vm._v(_vm._s(item.trainingName))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c(
                  "yxt-button",
                  {
                    staticClass: "result-list__select-clear",
                    attrs: { type: "text", disabled: !_vm.selectedList.length },
                    on: { click: _vm.clearAllSelection },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("pc_biz_cer_btn_clearall")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("pc_biz_core_btn_cancel")) + "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSelection } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_core_btn_determine")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }